import React from 'react'
import Avatar from '@mui/material/Avatar'
import { ICellRendererParams } from 'ag-grid-community'
import { ICON_SIZE } from '../../../BulkSheet/const'
import { Box, styled } from '@mui/material'
import { RootDiv } from '../../../commons/AgGrid/components/cell/CellRendererRoot'
import { useHistory } from 'react-router-dom'

interface Props extends ICellRendererParams {
  labelField: string
  iconUrlField: string
  url: string
  openInNewTab?: boolean
}

const StyledAvatar = styled(Avatar)({
  backgroundColor: '#DCDCDC',
  height: ICON_SIZE,
  width: ICON_SIZE,
  marginRight: '10px',
  cursor: 'pointer',
})

const StyledBox = styled(Box)({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  cursor: 'pointer',
  color: 'inherit',
  textDecoration: 'underline',
})

const UserLinkIconCellRenderer: React.FC<Props> = ({
  labelField,
  iconUrlField,
  url,
  openInNewTab,
  colDef,
}) => {
  const history = useHistory()

  if (!url || !colDef) return

  const handleClick = (e: React.MouseEvent) => {
    if (!url) return
    if (e.ctrlKey || e.metaKey || openInNewTab) {
      window.open(url, '_blank', 'noopener')
    } else {
      history.push(url)
    }
    e.preventDefault()
    e.stopPropagation()
  }
  return (
    <RootDiv className={`column-${colDef.field}`}>
      <StyledAvatar
        src={iconUrlField}
        variant="rounded"
        onClick={handleClick}
      />
      <StyledBox
        component={url ? 'a' : 'span'}
        {...(url && {
          href: url,
          rel: openInNewTab ? 'noopener' : undefined,
          target: openInNewTab ? '_blank' : undefined,
        })}
        onClick={handleClick}
      >
        {labelField}
      </StyledBox>
    </RootDiv>
  )
}

export default UserLinkIconCellRenderer
